import { useAtom } from 'jotai';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { bootstrapInfos } from 'store/public/bootstrapInfo';
import { setBootstrapInfoToLocal } from 'utils/js/bootstrapper';

const useGetBootstrapInfo = () => {
  const [loading, setLoading] = useState(true);

  const [bootstrapInfo, setBootstrapInfo] = useAtom(bootstrapInfos);

  const { enqueueSnackbar } = useSnackbar();

  const getBootstrapInfo = useCallback(async () => {
    setLoading(true);

    try {
      const res = await axiosClient.get('/SettingSystem/Bootstrapper');

      if (res.status === 200) {
        const items = res.data?.value;

        if (!Array.isArray(items)) {
          throw new Error('Invalid bootstrapper response');
        }

        const result = Object.fromEntries(
          items.map(item => [item.key, item.value]),
        );

        // Update global Jotai state
        setBootstrapInfo(result);

        // Update LocalStorage cache
        setBootstrapInfoToLocal(result);
      } else {
        enqueueSnackbar('Failed to fetch bootstrap info', {
          variant: 'error',
        });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [setBootstrapInfo, enqueueSnackbar]);

  return [getBootstrapInfo, loading, bootstrapInfo];
};

export default useGetBootstrapInfo;
